import React from 'react'
import { I18n } from '@front/volcanion'

import CPUtils from '@front/squirtle/utils/CPUtils'

import { Typography, Grid, Box } from '@mui/material'
import { TextField, ModelMenuSelectorField, MenuSelectorField } from '@front/squirtle'

const Title = props =>
  <Grid size={12}>
    <Typography variant={'h5'}> {I18n.t('pricerule.search')} </Typography>
  </Grid>

const Row1 = props =>
  <Grid container justifyContent="center" spacing={1} size={12}>
    <Grid size="grow">
      <ModelMenuSelectorField
        name={'commercial_packages'}
        label={I18n.t('commercialpackage.label', { count: -1 })}
        model_name='commercialpackage'
        labelKeys={['label']}
        loadOnMount
        searchMode={'search'}
        multiple
        config={{
          mutator: cp => ({ ...CPUtils.getTranslatedLabel(cp), ...cp })
        }}
      />
    </Grid>
    <Grid size="grow">
      <TextField name={'name'} label={I18n.t('name.label', { count: 1 })} />
    </Grid>
    <Grid size={2}>
      <MenuSelectorField
        name='accuracy'
        options={[
          { label: I18n.t('pricerule.accuracy.high'), value: 'high' },
          { label: I18n.t('pricerule.accuracy.low'), value: 'low' }
        ]}
        label={I18n.t('pricerule.accuracy.label')}
      />
    </Grid>
    <Grid size="grow">
      <ModelMenuSelectorField
        name='start_zone'
        label={I18n.t('zone.begin', { count: -1 })}
        model_name='zone'
        labelKeys={['name']}
        loadOnMount
        searchMode={'search'}
        multiple
      />
    </Grid>
    <Grid size="grow">
      <ModelMenuSelectorField
        name='end_zone'
        label={I18n.t('zone.end', { count: -1 })}
        model_name='zone'
        labelKeys={['name']}
        loadOnMount
        searchMode={'search'}
        multiple
      />
    </Grid>
  </Grid>

const SearchForm = props =>
  <Box sx={{ borderRadius: 1, boxShadow: 6, p: 1 }}>
    <Grid container rowSpacing={3}>
      <Title />
      <Row1 />
    </Grid>
  </Box>

export default React.memo(SearchForm)
